/**
 * Here is a two separated parts of original script with purposes:
 * - to setup analytical object for faster access
 * - to load a script
 *
 * Setup linkedin object but not load the script
 */
export const setup = () => {
  if (window.lintrk) return;
  const _linkedin_partner_id = '3999876';
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
  window._linkedin_data_partner_ids.push(_linkedin_partner_id);

  window.lintrk = function (a, b) {
    // Linkedin script removes queue after initialization, so we could
    // check for queue as init flag
    window.lintrk.q ? window.lintrk.q.push([a, b]) : window.lintrk(a, b);
  };
  window.lintrk.q = [];
};

/**
 * Load the script
 */
export const load = (config, onLoad, onError) => {
  const s = document.getElementsByTagName('script')[0];
  const b = document.createElement('script');
  b.type = 'text/javascript';
  b.async = true;
  b.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';

  if (onLoad) {
    b.onload = b.onreadystatechange = onLoad;
    b.onabort = onError || onLoad;
    b.onerror = onError || onLoad;
  }

  s.parentNode.insertBefore(b, s);
};
